import { combineReducers } from 'redux';
import plagiarismCaseQueue from 'app/queue/domains/plagiarism-case-queue/plagiarism-case-queue-reducer';
import plagiarismCaseQueueAsync from 'app/queue/domains/plagiarism-case-queue/plagiarism-case-queue-async-reducer';
import submissions from 'app/queue/domains/submissions/submissions-reducer';
import submissionsAsync from 'app/queue/domains/submissions/submissions-async-reducer';
import reviewsQueue from 'app/queue/domains/reviews-queue/reviews-queue-reducer';
import reviewsQueueAsync from 'app/queue/domains/reviews-queue/reviews-queue-async-reducer';
import questionQueue from 'app/queue/domains/question-queue/question-queue-reducer';
import questionQueueAsync from 'app/queue/domains/question-queue/question-queue-async-reducer';

export const plagiarismCasesReducer = combineReducers({
  queue: plagiarismCaseQueue,
  queueAsync: plagiarismCaseQueueAsync,
});

export const questionsReducer = combineReducers({
  queue: questionQueue,
  queueAsync: questionQueueAsync,
});

export const reviewsReducer = combineReducers({
  submissions,
  submissionsAsync,
  queue: reviewsQueue,
  queueAsync: reviewsQueueAsync,
});
